import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { RealtimeChannel } from '@supabase/supabase-js';

interface UseRealtimeSubscriptionOptions {
  table: string;
  event?: 'INSERT' | 'UPDATE' | 'DELETE' | '*';
  filter?: string;
  onInsert?: (payload: any) => void;
  onUpdate?: (payload: any) => void;
  onDelete?: (payload: any) => void;
  onChange?: (payload: any) => void;
}

export const useRealtimeSubscription = (options: UseRealtimeSubscriptionOptions) => {
  const [channel, setChannel] = useState<RealtimeChannel | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const channelName = `realtime:${options.table}:${Date.now()}`;

    const newChannel = supabase
      .channel(channelName)
      .on(
        'postgres_changes',
        {
          event: options.event || '*',
          schema: 'public',
          table: options.table,
          filter: options.filter,
        },
        (payload) => {
          if (options.onChange) {
            options.onChange(payload);
          }

          switch (payload.eventType) {
            case 'INSERT':
              if (options.onInsert) options.onInsert(payload);
              break;
            case 'UPDATE':
              if (options.onUpdate) options.onUpdate(payload);
              break;
            case 'DELETE':
              if (options.onDelete) options.onDelete(payload);
              break;
          }
        }
      )
      .subscribe((status) => {
        setIsConnected(status === 'SUBSCRIBED');
      });

    setChannel(newChannel);

    return () => {
      newChannel.unsubscribe();
    };
  }, [options.table, options.event, options.filter]);

  return { isConnected, channel };
};
